import * as React from "react";
import { Button, Modal, ModalProps, Sizes } from "react-bootstrap";
import { Utility } from "../../utils";
import { IComponentWithValidatedForm } from "../validation";

interface OptionalProps {
    headerClassName?: string;
    id?: string;
    labelCancel?: JSX.Element | string;
    labelSave?: JSX.Element | string;
    onCancel?: () => void;
    processingMessage?: JSX.Element | string;
    showProcessing?: boolean;
    bsSize?: Sizes;
    title?: JSX.Element | string;
}

type OwnProps = OptionalProps & {
    formComponent: IComponentWithValidatedForm;
    processing: boolean;
    show: boolean;
};

interface OwnState {
}

export class ModalForm<P, S> extends React.Component<P & OwnProps, S & OwnState> {

    public static defaultProps: OptionalProps = {
        id: `modal-${Utility.guid()}`,
        processingMessage: <Button bsStyle="primary"><i className="fa fa-spinner fa-spin"></i> Processing&hellip;</Button>,
        showProcessing: true,
    };

    public constructor(props: any) {
        super(props);
    }

    public onCancelClick() {
        if (this.props.onCancel)
            this.props.onCancel();
    }

    public onSaveClick() {
        this.props.formComponent.triggerSubmit();
    }

    public render() {
        let footer = <Modal.Footer>
            <Button bsStyle="link" onClick={() => this.onCancelClick()}>{this.props.labelCancel || "Cancel"}</Button>
            <Button bsStyle="primary" onClick={() => this.onSaveClick()}>{this.props.labelSave || "Save"}</Button>
        </Modal.Footer>;

        if (this.props.processing && this.props.showProcessing)
            footer = <Modal.Footer>{this.props.processingMessage}</Modal.Footer>;

        const modalProps: ModalProps = {
            backdrop: "static",
            id: this.props.id,
            keyboard: true,
            onEscapeKeyDown: () => !this.props.processing ? this.onCancelClick() : () => {},
            onHide: () => {},
            onShow: () => this.focusOnInput(),
            show: this.props.show,
        } as any; // needed "as any" here because "onEscapeKeyDown" does not exist in the latest typed definitions of react-bootstrap

        if (this.props.bsSize)
            modalProps.bsSize = this.props.bsSize;

        return <Modal { ...modalProps }>
                <Modal.Header
                    bsClass={"modal-header alert-" + (this.props.headerClassName || "info")}
                    closeButton={!this.props.processing}
                    onHide={() => this.onCancelClick()}
                >
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.props.children}
                </Modal.Body>

                {footer}
            </Modal>;
    }

    private focusOnInput() {
        const id = this.props.id || "";
        const modalEl = document.getElementById(id as string);
        if (modalEl) {
            // ,number,password,date
            const matches = modalEl.querySelectorAll(`input[type="text"], input[type="number"], input[type="password"], input[type="date"], textarea, select`);
            if (matches.length && typeof matches[0]["focus"] === "function") {
                matches[0]["focus"]();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalForm.tsx